import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAudio from 'vue-audio-better'
import VueClipboard from 'vue-clipboard2'

import videojs from 'video.js'
import 'video.js/dist/video-js.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/plugins/element.js'
// 导入公共样式
import '@/style/common.scss'
import '@/style/desc.scss'
import '@/style/text.scss'
import '@/style/index.scss'
import '@/style/phone.scss'

import VueAwesomeSwiper from 'vue-awesome-swiper'

// require styles
import 'swiper/dist/css/swiper.css'

Vue.prototype.$video = videojs
Vue.prototype.$http = axios

Vue.use(VueAwesomeSwiper /* { default global options } */)

Vue.use(VueAudio)
Vue.use(ElementUI)
Vue.use(VueClipboard)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
